export default __webpack_public_path__ + "static/media/marauders-map-v5.0-03-03.ba16d4e2.jpg";